<template>

  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Novo Contato" : "Alterar Contato" }}
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Nome <span class="red text">*</span></label>
            <input class="uppercase" v-model="contact.name" @blur="contact.name = $toUpperCase($event)">
          </div>     
        </div>
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Departamento</label>
            <input class="uppercase" v-model="contact.department" @blur="contact.department = $toUpperCase($event)">
          </div>
          <div class="eight wide field">
            <label class="form-label">E-mail</label>
            <input v-model="contact.email">
          </div>          
        </div>
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Telefone</label>
            <input v-model="contact.phone">
          </div>  
          <div class="eight wide field">
            <label class="form-label">Celular</label>
            <input v-model="contact.mobile">
          </div>  
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>            
      <button class="ui blue button" :class="{ disabled: !contact.name }" @click="onConfirm()">
        <i class="checkmark icon"></i>
        {{ isCreating ? "Confirmar" : "Atualizar" }}
      </button>
    </div>
  </div>  

</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"

  export default {

    name: "CustomerContactFormModal",

    mixins: [modalDialog],
    
    data() {
      return {
        contact: {},
      }
    },

    methods: {

      load(contact) {

        this.contact = {}

        if (contact)
          this.contact = this.$cloneObject(contact)

        this.show()
      },

      onConfirm() {

        const event = this.isCreating ? "onCreate" : "onUpdate"

        this.emit(event, this.$cloneObject(this.contact))
      },
    },
  }

</script>